import { createContext, useState, useEffect } from "react";

// Create the context
export const AuthContext = createContext();

// Helper to decode JWT
const decodeToken = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
};

// Provider component to wrap your app
export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token") || null);

  // Login function
  const login = (jwtToken) => {
    localStorage.setItem("token", jwtToken);
    setToken(jwtToken);
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
  };

  // ✅ Validate token on mount
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (!storedToken) {
      logout();
      return;
    }

    const decoded = decodeToken(storedToken);
    if (!decoded || Date.now() >= decoded.exp * 1000) {
      // Token expired or invalid
      logout();
    } else {
      // Token valid, set state
      setToken(storedToken);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
